module.exports = __webpack_public_path__ + "static/media/certificate.eccee3a3.svg";